import { Select } from 'antd'
import { IoIosSearch } from 'react-icons/io'

const { Option } = Select

export default function UserSelectCustom({
  options = [],
  value,
  onChange,
  onInputChange,
  disabled = false,
  placeholder = '',
  isClearable = false,
  height = '40px',
  isLoading = false,
}) {
  return (
    <Select
      className="custom-placeholder"
      showSearch
      allowClear={isClearable}
      value={value}
      disabled={disabled}
      loading={isLoading}
      placeholder={placeholder}
      style={{ width: '100%', height }}
      optionFilterProp="labelText"
      prefix={
        <IoIosSearch
          style={{
            color: 'var(--color-on-base-content-high)',
            fontSize: '28px',
          }}
        />
      }
      onSearch={onInputChange}
      onChange={(val, option) => {
        onChange?.(val, option) // ส่งต่อให้ parent
      }}
      filterOption={(input, option) =>
        option?.labelText?.toLowerCase().includes(input.toLowerCase())
      }
    >
      {options.map((item) => (
        <Option
          key={item.value}
          value={item.value}
          label={item.labelText} // string
          labelText={item.labelText} // string สำหรับ search
          data={item} // object เต็ม
        >
          {item.label} {/* JSX */}
        </Option>
      ))}
    </Select>
  )
}
